import React from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from './Logo';
import './AccessDeniedModal.css';

const AccessDeniedModal = ({ isOpen, message }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleTryLogin = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <div className="access-denied-modal-overlay">
      <div className="access-denied-modal" onClick={(e) => e.stopPropagation()}>
        <div className="access-denied-modal-header">
          <Logo variant="modal" />
        </div>
        <div className="access-denied-modal-content">
          <div className="access-denied-warning">
            {message || 'Ваша роль была удалена. Вы потеряли доступ к системе.'}
          </div>
          <button className="access-denied-button" onClick={handleTryLogin}>
            Попробовать войти
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccessDeniedModal;


